const FORMAT = 'devssoft-curriculums';
export const MAX_CV_FILE_BYTES = 5 * 1024 * 1024;

export function parseCvFile(text) {
  let file;
  try { file = JSON.parse(text.replace(/^\uFEFF/, '')); }
  catch { throw new Error('El archivo no contiene un JSON válido.'); }
  if (file?.format !== FORMAT || file.version !== 1 || !Array.isArray(file.curriculums) || !file.curriculums.length || file.curriculums.length > 200) {
    throw new Error('Selecciona un archivo de currículums exportado por DevsSoft (versión 1).');
  }
  return file.curriculums.map(cv => {
    if (!cv || typeof cv.name !== 'string' || !cv.name.trim() || cv.name.length > 200 || !cv.data || typeof cv.data !== 'object' || Array.isArray(cv.data) || !['es', 'en', 'pt'].includes(cv.language || 'es') || (cv.targetRole !== undefined && typeof cv.targetRole !== 'string')) {
      throw new Error('Uno de los currículums del archivo es inválido.');
    }
    // Account IDs, person IDs, revisions and Growth Planner links never cross accounts.
    return {name: cv.name.trim(), targetRole: cv.targetRole || '', language: cv.language || 'es', data: cv.data};
  });
}

export function serializeCvFile(documents) {
  const text = JSON.stringify({format: FORMAT, version: 1, curriculums: documents.map(cv => ({
    name: cv.name, targetRole: cv.targetRole || '', language: cv.language || 'es', data: cv.data
  }))}, null, 2);
  parseCvFile(text);
  if (new Blob([text]).size > MAX_CV_FILE_BYTES) throw new Error('El archivo supera 5 MB. Exporta menos currículums a la vez.');
  return text;
}

export function downloadCvFile(documents) {
  const text = serializeCvFile(documents);
  const url = URL.createObjectURL(new Blob([text], {type: 'application/json'}));
  const link = document.createElement('a');
  link.href = url;
  link.download = documents.length === 1 ? `${documents[0].name.replace(/[^\p{L}\p{N}_-]+/gu, '_').slice(0, 100) || 'curriculum'}.json` : 'curriculums.json';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
